<div class="zoom-controls">
    <i class="fas fa-search-plus hover icon" (click)="zoomIn()"></i>
    <i class="fas fa-search-minus hover" (click)="zoomOut()" [ngClass]="{'disabled': (imageScale$ | async) <= .3}"></i>
    <div class="zoom-percentage">{{MATH.round((imageScale$ | async) * 100)}}%</div>
</div>
